!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("dropdown", [], t) : "object" == typeof exports ? exports.dropdown = t() : e.dropdown = t();
}(this, function () {
  return function (e) {
    var t = {};
    function n(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(o, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 3);
  }([function (e, t) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }
    e.exports = n;
  },,, function (e, t, n) {
    (function (n) {
      var o, r, i;
      void 0 !== n || this.window || this.global, r = [], o = function () {
        "use strict";

        var e = {},
          t = ["click", "hover"],
          n = function n(e) {
            var n = e.getAttribute("data-event");
            return n && t.indexOf(n.toLowerCase()) >= 0 ? n : "click";
          },
          o = function o(e, t) {
            t.hasAttribute("hidden") ? r(e, t) : i(e, t);
          },
          r = function r(e, t) {
            t.removeAttribute("hidden"), e.setAttribute("aria-expanded", "true"), e.parentElement.classList.contains("flix-dropdown") && e.parentElement.classList.add("flix-dropdown--active");
          },
          i = function i(e, t) {
            t.setAttribute("hidden", ""), e.setAttribute("aria-expanded", "false"), e.parentElement.classList.remove("flix-dropdown--active");
          },
          u = function u(e) {
            for (var t = document.querySelectorAll(".flix-dropdown--active"), n = 0; n < t.length; n++) {
              var o = t[n],
                r = o.querySelector("[data-dropdown]"),
                u = o.querySelector("#" + r.getAttribute("data-dropdown"));
              null === r || null === u || o.contains(e.target) || i(r, u);
            }
          },
          d = function d(e, t) {
            "click" === n(e) && function (e, t) {
              e.addEventListener("click", function () {
                o(e, t);
              }), "BUTTON" !== e.tagName && e.addEventListener("keydown", function (n) {
                " " !== n.key && 32 !== n.keyCode && "Enter" !== n.key && 13 !== n.keyCode || o(e, t);
              });
            }(e, t), "hover" === n(e) && function (e, t) {
              var n;
              ["focus", "mouseenter"].forEach(function (o) {
                e.addEventListener(o, function () {
                  clearTimeout(n), n = setTimeout(r, "300", e, t);
                });
              }), e.addEventListener("mouseleave", function (o) {
                t.contains(o.relatedTarget) || (clearTimeout(n), n = setTimeout(i, "300", e, t));
              }), e.addEventListener("blur", function (o) {
                t.contains(o.relatedTarget) || (clearTimeout(n), n = setTimeout(i, "300", e, t));
              }), ["mouseleave", "focusout"].forEach(function (o) {
                t.addEventListener(o, function () {
                  clearTimeout(n), n = setTimeout(function () {
                    t.contains(document.activeElement) || i(e, t, o);
                  }, "300");
                });
              });
            }(e, t), e.addEventListener("keydown", function (n) {
              "Escape" !== n.key && "Esc" !== n.key && 27 !== n.keyCode || i(e, t);
            }), t.addEventListener("keydown", function (n) {
              "Escape" !== n.key && "Esc" !== n.key && 27 !== n.keyCode || i(e, t);
            });
          },
          c = function c(e, t) {
            var n = t.getAttribute("id"),
              o = t.hasAttribute("hidden");
            e.setAttribute("aria-controls", n), e.setAttribute("aria-expanded", !o), e.setAttribute("aria-haspopup", "menu");
          };
        return e.init = function () {
          for (var e = document.querySelectorAll("[data-dropdown]"), t = 0; t < e.length; t++) {
            var n = e[t],
              o = n.getAttribute("data-dropdown"),
              r = document.getElementById(o);
            null === r ? console.warn("dropdown.js plugin error: Cannot find element with id " + o + " for target " + n) : (c(n, r), d(n, r));
          }
          document.removeEventListener("click", u), document.addEventListener("click", u);
        }, e;
      }(), void 0 === (i = "function" == typeof o ? o.apply(t, r) : o) || (e.exports = i);
    }).call(this, n(0));
  }]);
});